import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-email-confirmed',
  imports: [
    ButtonModule,
    RouterModule,
    TranslatePipe
  ],
  templateUrl: './email-confirmed.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class EmailConfirmedComponent {

}
